module.exports = __webpack_public_path__ + "static/blog49-c3b7aeccdfb82c0a33b7bad5bc57977f.png";